<template>
	<div v-if="open" class="overlay-modal">
		<div class="overlay-modal-bg" @click="closeOverlayModal"></div>
		<div class="overlay-modal-content">
			<div class="overlay-modal-bar" @click="closeOverlayModal">
				<h3 v-if="overlayModalTitle" class="title">{{ overlayModalTitle }}</h3>
				<div class="close">
					<i class="ri-close-line"></i>
				</div>
			</div>
			<component v-if="overlayContentComp" :is="overlayContentComp" />
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			open: false,
		};
	},
	watch: {
		isOpenOverlayModal: {
			handler(open) {
				this.open = open;
			},
			immediate: true,
		},
	},
	computed: {
		isOpenOverlayModal() {
			return this.$store.getters['appStore/isOpenOverlayModal'];
		},
		overlayContentComp() {
			return this.$store.getters['appStore/overlayContentComp'];
		},
		overlayModalTitle() {
			return this.$store.getters['appStore/overlayModalTitle'];
		},
	},
	methods: {
		closeOverlayModal() {
			this.$closeOverlayModal();
			this.reset();
		},
		reset() {
			this.$setOverlayModalTitle({ title: '' });
			this.$setOverlayContentComp({ component: null });
		},
	},
};
</script>

<style scoped>
.overlay-modal {
	position: fixed;
	z-index: 9999;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: center;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	padding: 20px;
}

.overlay-modal-bg {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
}

.overlay-modal-content {
	position: relative;
	max-height: 100%;
	overflow-y: auto;
	border-radius: 4px;
	background: #fff;
}

.overlay-modal-bar {
	position: sticky;
	top: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #fff;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
	padding: 0.5em 1em;
	margin-left: auto;
	color: #000;
	font-size: 20px;
	font-weight: 700;
}

.overlay-modal-bar .title {
	font-size: 1rem;
	font-weight: 700;
}
</style>
